import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import React, { memo, useMemo } from 'react';
import { FinAssetDeprScheduleResponse } from '../../../../../services/finassets';
import { toCurrency } from '../../../../../utils/utils';

type DeprecationScheduleTableProps = {
  deprecationSchedules?: FinAssetDeprScheduleResponse[];
  currcode?: string;
};

const DeprecationScheduleTable = (props: DeprecationScheduleTableProps) => {
  const { deprecationSchedules, currcode } = props;

  const columns = useMemo<DataGridColDef<FinAssetDeprScheduleResponse>[]>(
    () => [
      {
        comcode: 'deprschedule.startdate',
        dataIndex: 'startdate',
        width: 150,
        fixed: 'left',
      },
      {
        comcode: 'deprschedule.enddate',
        dataIndex: 'enddate',
        width: 150,
        align: 'left',
      },
      {
        comcode: 'deprschedule.basisstartamount',
        dataIndex: 'basisstartamount',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
      },
      {
        comcode: 'deprschedule.deprlinearamount',
        dataIndex: 'deprlinearamount',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
      },
      {
        comcode: 'deprschedule.deprdegressiveamount',
        dataIndex: 'deprdegressiveamount',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
      },
      {
        comcode: 'deprschedule.fiscalamountend',
        dataIndex: 'fiscalamountend',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
      },
      {
        comcode: 'deprschedule.accountingreference',
        dataIndex: 'accountingreference',
        width: 150,
        align: 'left',
      },
      {
        comcode: 'deprschedule.accountingdate',
        dataIndex: 'accountingdate',
        width: 150,
        align: 'left',
      },
    ],
    [currcode]
  );

  return (
    <DataGrid
      pagination={{ pageSize: 1000 }}
      scroll={{ y: 320 }}
      dataSource={deprecationSchedules}
      columns={columns}
      rowKey={(record) => record.deprlineid}
    />
  );
};

export default memo(DeprecationScheduleTable);
